var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { OfferBanner, OfferType, PageID, Theme } from '@sales/offer-banner';
import * as cartUiUtils from '@idse/cart-ui/utils/UtilityFunctions';
import * as cartUtils from '@idse/cart-ui/utils/CartUtilFunctions';
import FirstNetSignOnModel from '@idse/cart-ui/components/CartConfigurationContainer/FirstNetSignOnModel/FirstNetSignOnModel';
import * as styles from './Cart.container.scss';
var FanBanner = /** @class */ (function (_super) {
    __extends(FanBanner, _super);
    function FanBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FanBanner.prototype.render = function () {
        return (this.renderOfferBanner());
    };
    FanBanner.prototype.renderOfferBanner = function () {
        var privateOffer = false;
        var privateBBOffer = false;
        var campaignId = cartUiUtils.getCampaignSessionId();
        var payload = cartUiUtils.getCartResp();
        if (payload && payload.enablePrivateOfferBannerDisplay) {
            if (payload.wirelessCart && payload.wirelessCart.privateOfferApplied) {
                privateOffer = true;
            }
            if (cartUiUtils.IsBroadbandInCart()) {
                privateBBOffer = true;
            }
        }
        if ((cartUiUtils.IsWirelessInCart() || cartUiUtils.IsBroadbandInCart() ||
            cartUiUtils.IsAccessoryOnlyInCart())
            && cartUiUtils.getCurrentFlowType() !== cartUiUtils.LOBNames.LOB_PREPAID
            && !cartUtils.isSMBCustomer() && (payload.enableSignatureEnhancedExperience || privateOffer
            || privateBBOffer)) {
            var isFirstNetUser = cartUtils.isFNIntentPresent() || cartUtils.isFNUserWithConsumerLine();
            return (React.createElement("div", null,
                React.createElement(OfferBanner, { pageID: PageID.CART, expandOnLoad: false, theme: Theme.DARK, offerType: privateBBOffer ? OfferType.Private : undefined, fnIntent: isFirstNetUser, campaignIdHeader: campaignId }),
                cartUtils.isFNIntentSignOnRequired() && this.showFirstNetSignOnModel()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    FanBanner.prototype.showFirstNetSignOnModel = function () {
        var payload = cartUiUtils.getCartResp();
        var firstName = '';
        if (payload
            && payload.authDetails &&
            payload.authDetails.firstName) {
            firstName = payload.authDetails.firstName;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.firstNetDiv },
                React.createElement("div", { className: styles.firstNetLine })),
            React.createElement("div", { className: styles.firstNetBanner },
                React.createElement(FirstNetSignOnModel, { firstName: firstName, onEdit: this.redirectToBuyFlow }))));
    };
    FanBanner.prototype.redirectToBuyFlow = function () {
        var _a, _b, _c;
        var payload = cartUiUtils.getCartResp();
        var editUrl = (_c = (_b = (_a = payload.metadata) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.wirelessMetadata) === null || _c === void 0 ? void 0 : _c.editUrl;
        window.location.href = editUrl;
    };
    return FanBanner;
}(React.Component));
export default FanBanner;
//# sourceMappingURL=FanBanner.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/Cart/FanBanner.js
// module id = 976
// module chunks = 8